import { fetch } from 'whatwg-fetch';

export function makeRequest(url, requestMethod = 'GET', requestHeaders, requestBody) {
  return fetch(url, {
    method: requestMethod,
    headers: requestHeaders,
    body: requestBody,
  })
    .then((response) => {
      if (response.redirected) {
        window.location.href = '/logout';
      } else if (response.status === 200) {
        return response.text();
      }
      throw response.statusText;
    });
}

export function QueryStringBuilder() {
  const nameValues = [];

  this.add = function (name, value) {
    nameValues.push({
      name,
      value,
    });
  };

  this.toQueryString = function () {
    const segments = [];
    let nameValue;
    nameValues.forEach((value, i) => {
      nameValue = value;
      segments[i] = `${encodeURIComponent(nameValue.name)}=${encodeURIComponent(nameValue.value)}`;
    });

    return segments.join('&');
  };
}

export function getId(event) {
  const element = event.currentTarget;
  return element.querySelector('span.number')
    .getAttribute('data-number');
}

export function addToElement(query = '', callbackOnResponse, response) {
  const replaceAt = document.querySelector(query);
  if (!callbackOnResponse) {
    replaceAt.innerHTML = response;
    return;
  }
  const content = document.createRange()
    .createContextualFragment(response);
  callbackOnResponse(content);
  replaceAt.innerHTML = '';
  replaceAt.appendChild(content);
}

export function appendToElement(query = '', callbackOnResponse, response) {
  const element = document.querySelector(query);
  if (!callbackOnResponse) {
    element.insertAdjacentHTML('beforeend', response);
    return;
  }
  const content = document.createRange()
    .createContextualFragment(response);
  callbackOnResponse(content);
  element.appendChild(content);
}

export function requestPagination(event, options) {
  const opts = buildOptions(options);
  const requestUrl = `${opts.requestPathName}?offset=${opts.offset}&limit=${opts.limit}&status=${opts.status}&${opts.filters}`;

  return makeRequest(requestUrl)
    .then(appendToElement.bind(null, opts.renderLocation, opts.callback));
}

export function requestFilter(event, options) {
  const opts = buildOptions(options);
  const requestUrl = `${opts.requestPathName}?${opts.filters}`;

  return makeRequest(requestUrl)
    .then(addToElement.bind(null, opts.renderLocation, options.callback));
}

export function getDataFilters() {
  const filtersElementData = document.querySelector('.js--filters-data');
  const filtersElement = document.querySelector('.js--filters');

  if (filtersElementData && filtersElement) {
    const filtersData = filtersElementData.dataset.filters;
    filtersElement.value = filtersData;
  }
}

function buildOptions(options) {
  const defaults = {
    renderLocation: '',
    filterSelector: '.js--filter-section',
    requestPathName: '',
    offset: '',
    limit: '',
    callback: null,
    status: '',
  };

  return (Object).assign({}, defaults, options);
}
